// src/components/common/Breadcrumbs.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumbs.css';

// Fonction pour transformer un segment de chemin en un nom lisible
const getPathFriendlyName = (pathSegment, fullPath, projectsData = []) => {
  if (!pathSegment) return '';

  // Gérer les slugs de projet
  if (fullPath.startsWith('/realisations/') && pathSegment !== 'realisations') {
    const project = projectsData.find(p => p.slug === pathSegment);
    return project ? project.title : pathSegment.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  }

  // Cas spécifiques pour les noms des routes
  const nameMap = {
    'a-propos': 'À Propos',
    'mentions-legales': 'Mentions Légales',
    'politique-confidentialite': 'Politique de Confidentialité',
    'realisations': 'Réalisations',
    'services': 'Services',
    'tarifs': 'Tarifs',
    'contact': 'Contact',
    // Ajoute d'autres conversions ici si nécessaire
  };

  if (nameMap[pathSegment.toLowerCase()]) {
    return nameMap[pathSegment.toLowerCase()];
  }

  // Par défaut, remplace les tirets et met en majuscule la première lettre de chaque mot
  return pathSegment.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
};

function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x); // Divise le chemin et enlève les vides

  // Tu devras importer tes projectsData ici si tu veux afficher les titres des projets
  // Pour cet exemple, je le laisse en commentaire. Si tu ne l'importes pas, le slug sera affiché.
  // import { projectsData } from '../../data/projectsData'; // Décommente et ajuste le chemin si besoin

  if (location.pathname === '/') {
    return null; // Ne pas afficher le fil d'Ariane sur la page d'accueil
  }

  return (
    <div className="breadcrumbs-container">
      <nav aria-label="breadcrumb" className="container breadcrumbs-nav">
        <ol className="breadcrumbs-list">
          <li className="breadcrumb-item">
            <Link to="/">Accueil</Link>
          </li>
          {pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            // Pour la recherche de titre de projet, passe projectsData à getPathFriendlyName
            // const displayName = getPathFriendlyName(value, location.pathname, projectsData);
            const displayName = getPathFriendlyName(value, location.pathname);


            return (
              <React.Fragment key={to}>
                <li className="breadcrumb-separator" aria-hidden="true">/</li>
                <li className="breadcrumb-item">
                  {isLast ? (
                    <span className="breadcrumb-active" aria-current="page">{displayName}</span>
                  ) : (
                    <Link to={to}>{displayName}</Link>
                  )}
                </li>
              </React.Fragment>
            );
          })}
        </ol>
      </nav>
    </div>
  );
}

export default Breadcrumbs;